import React, { FC } from 'react';

import {
  GeneralPageContent,
  HomePageContent,
  PillarPageContent,
  ContentPageType,
  RentalCompanyPageContent,
  SeaPageContent,
  SupplierRatingsPageContent,
  TransporterPageContent,
  PlainPageContent,
  PromoPageContent,
  MinimalPageContent,
} from '@silvertours/common-landingpages-view';

import { GeneralContent } from './General';
import { PillarContent } from './Pillar';
import { RentalCompanyContent } from './RentalCompany';
import { SeaContent } from './Sea';
import { SupplierRatingsContent } from './SupplierRatings';
import { TransporterContent } from './Transporter';
import { HomeContent } from './Home';
import { LandingPageProps, PageProps } from '../LandingPageProps';
import { ReviewsPillarContent } from './ReviewsPillar';
import { PlainPage } from '../common/Plain';
import { MinimalPage } from '../common/Minimal';
import { PromoPage } from '../common/Promo';

const isPageOfType = <TContent extends Record<string, unknown>>(
  contentPageType: ContentPageType,
  props: PageProps<ContentPageType, Record<string, unknown>>,
): props is PageProps<ContentPageType, TContent> =>
  props.content.type === contentPageType;

const LandingPage: FC<LandingPageProps> = (props: LandingPageProps) => {
  if (isPageOfType<HomePageContent>('home', props)) {
    return <HomeContent {...props} />;
  }

  if (isPageOfType<GeneralPageContent>('general', props)) {
    return <GeneralContent {...props} />;
  }

  if (isPageOfType<PillarPageContent>('pillar', props)) {
    return <PillarContent {...props} />;
  }

  if (isPageOfType<GeneralPageContent>('reviewsPillar', props)) {
    return <ReviewsPillarContent {...props} />;
  }

  if (isPageOfType<RentalCompanyPageContent>('rentalCompany', props)) {
    return <RentalCompanyContent {...props} />;
  }

  if (isPageOfType<SupplierRatingsPageContent>('supplierRatings', props)) {
    return <SupplierRatingsContent {...props} />;
  }

  if (isPageOfType<TransporterPageContent>('transporter', props)) {
    return <TransporterContent {...props} />;
  }

  if (isPageOfType<PlainPageContent>('plain', props)) {
    return <PlainPage {...props} />;
  }

  if (isPageOfType<MinimalPageContent>('minimal', props)) {
    return <MinimalPage {...props} />;
  }

  if (isPageOfType<PromoPageContent>('promo', props)) {
    return <PromoPage {...props} />;
  }

  if (isPageOfType<SeaPageContent>('sea', props)) {
    return <SeaContent {...props} />;
  }

  return null;
};

export { LandingPage };
export type { PageProps };
